/**
 * Utilitário centralizado para obter URLs da API no app clinics
 */

export function getClinicsApiBaseURL(): string {
  return (
    import.meta.env.VITE_CLINIC_API_URL ||
    import.meta.env.VITE_CLINICS_API_URL ||
    '/clinic'
  );
}

export function getUploadsBaseURL(): string {
  return `${getClinicsApiBaseURL()}/uploads`;
}
